<p-fieldset legend="Studium">
  <div class="flex flex-col gap-4 pt-2">
    <p-floatlabel class="w-full" variant="on">
      <input id="Hochschule" class="w-full" type="text" pInputText appTrTrim [formControl]="studiumFormGroup!.controls.hochschule" />
      <label for="Hochschule">Hochschule*</label>
    </p-floatlabel>

    <p-floatlabel class="w-full" variant="on">
      <input id="Fachrichtung" class="w-full" type="text" pInputText appTrTrim [formControl]="studiumFormGroup!.controls.fachrichtung" />
      <label for="Fachrichtung">Fachrichtung</label>
    </p-floatlabel>

    <div class="flex flex-col md:flex-row gap-y-8 md:gap-x-4">
      <p-floatlabel class="w-full" variant="on">
        <p-select
          fluid
          inputId="(Angestrebter) Abschluss"
          [formControl]="studiumFormGroup!.controls.abschluss"
          [options]="diploma"
          [optionValue]="'value'"
          dropdownIcon="pi-angle-down"
          optionLabel="value"
          (onChange)="diplomaChange($event)"
        />
        <label for="(Angestrebter) Abschluss">(Angestrebter) Abschluss</label>
      </p-floatlabel>

      <p-floatlabel class="w-full" variant="on">
        <input id="Anderer Abschluss" type="text" pInputText fluid appTrTrim [formControl]="studiumFormGroup!.controls.andererAbschluss" />
        <label for="Anderer Abschluss">Anderer Abschluss</label>
      </p-floatlabel>
    </div>

    <app-date-range [vonDate]="studiumFormGroup!.controls.von" [bisDate]="studiumFormGroup!.controls.bis"></app-date-range>
  </div>
  <div class="flex flex-row justify-end items-end pt-2">
    <p-button severity="danger" outlined type="button" (click)="remove.emit()" icon="pi pi-trash" label="Löschen"></p-button>
  </div>
</p-fieldset>
